import React, { Component } from 'react';

import classnames from 'classnames';

// Material UI Imports
import Avatar from '@material-ui/core/Avatar';
import Card from '@material-ui/core/Card';
import CardHeader from "@material-ui/core/CardHeader";
import CardText from "@material-ui/core/CardContent";

import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import IconButton from '@material-ui/core/IconButton';
import Collapse from '@material-ui/core/Collapse';
import { withStyles } from '@material-ui/core/styles'

// Material Icons Imports
import IconActionEvent from '@material-ui/icons/Event';

// Components Imports
import DailyEntry from './DailyEntry';

const cardStyles = {
    card: {
        marginTop: 5,
        marginBottom: 10,
        boxShadow: "none",
        cursor:"pointer",
    },
    header: {
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-start",
        title: {
            fontWeight: 400,
        }
    },
    text: {
        paddingTop: 0,
        paddingBottom: 0,
    },
};

const styles  = theme => ({
    expand: {
        transform: 'rotate(0deg)',
        transition: theme.transitions.create('transform', {
            duration: theme.transitions.duration.shortest,
        }),
        marginLeft: 'auto',
        [theme.breakpoints.up('sm')]: {
            marginRight: -8,
        },
    },
    expandOpen: {
        transform: 'rotate(180deg)',
    },
    avatar: {
        backgroundColor: theme.palette.primary.main,
      },
})

class DailyEntryDate extends Component {

    state = { expanded: this.props.initiallyExpanded };

    handleExpandClick = () => {
        this.setState(state => ({ expanded: !state.expanded }));
    };

    render() {
        const { classes } = this.props;

        const dailyEntriesList = this.props.dailyEntries.map((dailyEntry, id) =>
            <DailyEntry dailyEntry={dailyEntry} key={id} initiallyExpanded={this.props.initiallyExpanded} />
        );

        return (
            <div className="DailyEntryDate">
                <Card style={cardStyles.card}>
                    <CardHeader
                        title={this.props.dailyEntryDate}
                        avatar={<Avatar className={classes.avatar}><IconActionEvent /></Avatar>}
                        style={cardStyles.header}
                        onClick={this.handleExpandClick}
                        action={
                            <IconButton
                                className={classnames(classes.expand, {
                                    [classes.expandOpen]: this.state.expanded,
                                })}
                                aria-expanded={this.state.expanded}
                                aria-label="Show more"
                            >
                                <ExpandMoreIcon />
                            </IconButton>
                        }
                    />
                    <CardText style={cardStyles.text} >
                        <Collapse in={this.state.expanded} timeout="auto" unmountOnExit>
                            {dailyEntriesList}
                        </Collapse>
                    </CardText>
                </Card>
            </div>
        );
    }
}
export default withStyles(styles)(DailyEntryDate);


// WEBPACK FOOTER //
// src/components/innerComponents/DailyEntryDate.js